// Mapping of Life Plan Canvas box titles to backend keys
// Each box can have a single key (string) or multiple keys (array of strings)
export const lifePlanBoxKeyMap: Record<string, string | string[]> = {
  // Vision: Using multiple keys as shown in the image
  "Vision": "vision_statement",

  // Mission: Using the core mission key
  "Mission": "core_mission",

  // Core Values: Using core_values as the key
  "Core Values": "core_values",

  // Core Motivations: Using Top_motivations as the key
  "Core Motivations": "Top_motivations",

  // Beneficiaries: Using main_beneficiary as shown in the image
  "Beneficiaries (People impacted by your life)": "main_beneficiary",

  // Top Priorities: Using top_priorities as shown in the image
  "Top Priorities (Direction)": "top_priorities",

  // Best Self + Strengths: Using multiple keys as shown in the image
  "Best Self + Strengths": ["3_words", "emotions_best", "doing_best", "people_best", "strengths_swot","strengths_more"],

  // Stop: Using multiple keys as shown in the image
  "Stop": ["yearone_stop", "yearthree_stop", "yearten_stop", "values_stop"],

  // Start: Using multiple keys as shown in the image
  "Start": ["yearone_start", "yearthree_start", "yearten_start"],
};
